import React from 'react'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'

// Quando a mantenedora tem mais de uma chamada, o candidato escolhe qual. O título
// é o que a mantenedora cadastrou — "Chamada Escolar 2026", "Chamada Escolar EJA
// 1º Semestre 2026" — então mostramos como está.
const PublicCallChooser = ({ publicCalls, classes, sm, onChoose }) => (
  <>
    <Typography
      className={classes[sm ? 'description-sm' : 'description']}
      variant="body1"
    >
      Escolha o processo em que deseja se inscrever
    </Typography>

    <div className={classes['buttons-sm']}>
      {publicCalls.map(item => (
        <Button
          key={item.id}
          className={classes['button-sm']}
          variant="contained"
          color="primary"
          onClick={() => onChoose(item.id)}
        >
          <span style={{ display: 'flex', flexDirection: 'column' }}>
            <span>{item.name}</span>
            {item.statusLabel && (
              <span style={{ fontSize: '0.75rem', opacity: 0.85 }}>
                {item.statusLabel}
              </span>
            )}
          </span>
        </Button>
      ))}
    </div>
  </>
)

export default PublicCallChooser
